<script>
import { Bar } from 'vue-chartjs'

import { dashBoardMethods } from '@state/helpers'

export default {
  extends: Bar,
  props: {
    date: {
      type: String,
      default: null,
    },
  },
  async mounted() {

    console.log(this.date)

    try{

      const { success, message, data: { result } } = await this.monthGraph(this.date)

      if(!success) throw new Error(message)

      const { last , current } = result;

      this.renderChart(
        {
          labels: [
            '01', '02', '03', '04', '05', '06', '07', '08', '09', '10',
            '11', '12','13', '14','15', '16','17', '18','19', '20',
            '21', '22','23', '24','25', '26','27', '28','29', '30', '31'
          ],
          datasets: [
            {
              label: 'Current month',
              backgroundColor: '#1abc9c',
              borderColor: '#1abc9c',
              hoverBackgroundColor: '#1abc9c',
              hoverBorderColor: '#1abc9c',
              data: current,
            },
            {
              label: 'Last month',
              backgroundColor: '#e3eaef',
              borderColor: '#e3eaef',
              hoverBackgroundColor: '#e3eaef',
              hoverBorderColor: '#e3eaef',
              data: last,
            },
          ],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false,
          },
          scales: {
            yAxes: [
              {
                gridLines: {
                  display: false,
                },
                stacked: false,
                ticks: {
                  stepSize: 20,
                },
              },
            ],
            xAxes: [
              {
                barPercentage: 0.7,
                categoryPercentage: 0.5,
                stacked: false,
                gridLines: {
                  color: 'rgba(0,0,0,0.01)',
                },
              },
            ],
          },
        }
      )
    }
    catch (e){
      this.appToast('Error', e.message || 'Error while operating', 'danger')
    }
  },

  methods: {
    ...dashBoardMethods
  }
}
</script>